import { Capacitor, registerPlugin } from '@capacitor/core'
import { Preferences as PreferencesPlugin } from '@capacitor/preferences'

// Capacitor의 PreferencesPlugin은 UserDefaults.standard를 사용하여 NotificationService와 같은 extension과 같이 사용할 수 없다.
// 이 문제로 인해 Capacitor의 PreferencePlugin을 사용하지 않고 별도의 SharedPreferencesPlugin을 만들어서 사용한다.
const SharedPreferencesPlugin = registerPlugin('SharedPreferencesPlugin')

const Preferences = Capacitor.isNativePlatform() && Capacitor.getPlatform() == 'ios' ?
  SharedPreferencesPlugin as unknown as typeof PreferencesPlugin : // ios
  PreferencesPlugin // android, web

export async function initPreferences () {
  if (!Capacitor.isNativePlatform()) {
    // web인 경우 localStorage 사용 (group이 NativeStorage인 경우 prefix가 따로 붙지 않음)
    const group = 'NativeStorage'
    await PreferencesPlugin.configure({ group })
  }
  // if (Capacitor.isNativePlatform()) {
  //   if (Capacitor.getPlatform() !== 'ios') {
  //     // android는 default group 사용 (group이 NativeStorage인 경우 prefix가 따로 붙지 않음)
  //     const group = 'NativeStorage'
  //     await PreferencesPlugin.configure({ group })
  //   }
  // } else {
  //   // web인 경우 localStorage 사용 (group이 NativeStorage인 경우 prefix가 따로 붙지 않음)
  //   const group = 'NativeStorage'
  //   await PreferencesPlugin.configure({ group })
  // }
}

const prefix = 'Beezvalley_'

function makeKey (key: string) {
  return `${prefix}${key}`
}

export async function keys () {
  const result = await Preferences.keys()
  return result.keys.filter((k) => k.startsWith(prefix)).map((k) => k.replace(prefix, ''))
}

export async function get (key: string, type: string): Promise<unknown> {
  key = makeKey(key)
  const result = await Preferences.get({ key })
  const value = result.value

  if (value == null) {
    return undefined
  }
  if (type == 'number') {
    return Number(value)
  } else if (type == 'boolean') {
    return value === 'true'
  } else if (type == 'object') {
    return JSON.parse(value)
  }

  return value
}

export async function set (key: string, value: unknown) {
  if (value == null) {
    remove(key)
    return
  }

  key = makeKey(key)
  let value_: string
  if (typeof value == 'string') {
    value_ = value
  } else if (typeof value == 'object') {
    value_ = JSON.stringify(value)
  } else {
    value_ = String(value)
  }
  await Preferences.set({ key, value: value_ })
  // if (Capacitor.isNativePlatform()) {
  //   await Preferences.set({ key, value: value_ })
  // } else {
  //   localStorage.setItem(key, value_)
  // }
}

export async function remove (key: string) {
  key = makeKey(key)
  await Preferences.remove({ key })
  // if (Capacitor.isNativePlatform()) {
  //   await Preferences.remove({ key })
  // } else {
  //   localStorage.removeItem(key)
  // }
}

export async function clear (key: string) {
  await Preferences.clear()
  // if (Capacitor.isNativePlatform()) {
  //   await Preferences.clear()
  // } else {
  //   localStorage.clear()
  // }
}
